import { Typography, Box } from '@mui/material'
import { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
const StepperCard= ({ id, text, index, moveCard, disable = false, activeStep }) => {
  const ref = useRef(null)
  const [handlerId , drop] = useDrop({
    accept: 'stepper',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = (clientOffset).y - hoverBoundingRect.top
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      moveCard(dragIndex, hoverIndex)
      item.index = hoverIndex
    },
  })

  const [{ isDragging }, drag] = useDrag({
    type: 'stepper',
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const opacity = isDragging ? 0 : 1
  drag(drop(ref))

  return (
    <Box justifyItems={'center'}  gap={1} ref={disable ? null : ref} data-handler-id={handlerId} sx={{opacity: isDragging ? 0 : 1 , cursor : disable ? 'default': 'move'}}>
      <Box display={'flex'} alignItems={'center'}><Typography sx={{border: '1px solid #000', borderRadius: '50%', width: '20px', textAlign:'center', backgroundColor: activeStep == index ? 'blue' : '#fff', color: activeStep == index ? '#fff' : '#000' }}>{index +1}</Typography></Box><Typography>{text}</Typography>
    </Box>
  )
}

//{index < 5  ? <Typography sx={{height: '2px',width: '30px', backgroundColor: '#000'}}></Typography> : ''}
export default StepperCard